export default __webpack_public_path__ + "static/media/payouts.52080420.svg";